import { Container } from "src/components/container"
import { Image } from "src/components/Image"
import { IbanBTC, IbanSpeed, IbanUserCheck, IbanWallet, StarIcon } from "src/icons"
import { Chip } from "../../components/Chip"
import { Card } from "./Card"
import "./index.scss"

export const IBANHub = () => {
  return (
    <div className="hub">
      <Container>
        <div className="hub__main-card">
          <Chip icon={<StarIcon />} title="Why use 7Gates" />
          <h1>Your Ultimate Finance Hub: Crypto Top-Ups, Global Payments, and Custom IBANs</h1>
        </div>
        <div className="hub__grid">
          <Card icon={<IbanSpeed />} title="Quick & Simple Onboarding">
            Start in no time with minimal paperwork and quick access to your IBAN. No banking hassles—just connect and go.
          </Card>
          <Card icon={<IbanWallet />} title="Comprehensive SEPA & SWIFT Support">
            Effortlessly send and receive international payments, with full compatibility for both SEPA and SWIFT networks, ensuring
            reliable global banking.
          </Card>
          <Card icon={<IbanBTC />} title="Ideal for Crypto-Focused Professionals">
            Seamlessly manage income from Web3, DeFi, freelancing, or IT services, combining crypto and traditional finance in one
            convenient account.
          </Card>
          <Card icon={<IbanUserCheck />} title="Personalized IBAN for You or Your Business">
            Get a unique IBAN issued specifically for you or your company—perfect for building trust with clients, partners, and financial
            institutions.
          </Card>
          <Card icon={<IbanSpeed />} title="Crypto Top-Up Made Easy">
            Easily deposit cryptocurrencies (BTC, ETH, USDT, etc.) into your vIBAN for quick conversions to fiat, ensuring instant access
            and smooth global transactions.
          </Card>
          <div className="hub-img">
            <Image src="/iban/iban-hub.png" />
          </div>
        </div>
      </Container>
    </div>
  )
}
